import * as React from "react";
import useGeolocation from "common/hooks/useGeolocation";
import Button from "components/Button";
import Greeting from "./Greetings";
import Logo from "assets/images/logo.png";
import styles from "./styles.module.scss";

const FirstScreen = ({ setIsFirstScreen }) => {
  const access = useGeolocation();

  return (
    <div className={styles['first-screen']}>
      <img className={styles.logo} src={Logo} alt="logo" />
      <div className={styles["container"]}>
        <Greeting />
        <Button
          isActive={access !== "asking"}
          onClick={() => {
            setIsFirstScreen(false);
          }}
        >
          Начать
        </Button>
      </div>
    </div>
  );
};

export default FirstScreen;
